import _slicedToArray from "/home/jenkins/workspace/web_bgm/bgm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import e from "../node_modules/@babel/runtime/helpers/esm/extends.js";
import t, { useState as o, Fragment as n } from "react";
import s from "./components/header/index.js";
import r from "./components/slider/index.js";
import "./components/slider/menu.js";
import l from "./components/fastnav/index.js";
import "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./components/scrollbar/index.scss.js";
import { Layout as a, Drawer as m, BackTop as i } from "antd";
import "./index.scss.js";
var c = a.Content;
export default (function (_ref) {
  var p = _ref.routeList,
      d = _ref.avatar,
      u = _ref.username,
      b = _ref.logoUrl,
      g = _ref.name,
      f = _ref.children,
      h = _ref.onSignOut,
      E = _ref.isMobile,
      y = _ref.title;

  var _o = o(!0),
      _o2 = _slicedToArray(_o, 2),
      x = _o2[0],
      j = _o2[1],
      v = function v(e) {
    j(e);
  },
      C = p.filter(function (e) {
    return void 0 !== e.id;
  }),
      L = {
    menus: C,
    collapsed: x,
    onCollapseChange: v,
    avatar: d || "",
    username: u || "",
    fixed: !0,
    title: y,
    onSignOut: function onSignOut() {
      h && h();
    }
  },
      k = {
    menus: C,
    isMobile: E,
    collapsed: x,
    onCollapseChange: v,
    name: g || "",
    logoUrl: b || "https://baleen-cdn-g.bybieyang.com/static/images/mini/square_logo.png"
  };

  return t.createElement(n, null, t.createElement(a, null, E ? t.createElement(m, {
    maskClosable: !0,
    closable: !1,
    onClose: function onClose() {
      return v(!x);
    },
    visible: !x,
    placement: "left",
    width: 200,
    style: {
      padding: 0,
      height: "100vh"
    }
  }, t.createElement(r, e({}, k, {
    collapsed: !1
  }))) : t.createElement(r, k), t.createElement("div", {
    className: "skeleton-container",
    id: "primaryLayout"
  }, t.createElement(s, L), t.createElement(c, {
    className: "content"
  }, t.createElement(l, {
    routeList: p
  }), f), t.createElement(i, {
    className: "backTop",
    target: function target() {
      return document.querySelector("#primaryLayout");
    }
  }))));
});